import { UserTypeEnum } from "~/constants/UserConstants";
import useCurrentUser from "~/hooks/useCurrentUser";

const useIsSuperAdmin = () => {
  const user = useCurrentUser();
  return user?.user_type === UserTypeEnum.SUPER_ADMIN;
};

export default useIsSuperAdmin;
